import React from 'react'

const InteractiveDemo = () => {
    return (
        <>
            <iframe
                title="Interactive Demo"
                src="/interactive-demo.html"
                style={{
                    width: '100%',
                    height: '100vh',
                    border: 'none'
                }}
            />
        </>
    );
}

export default InteractiveDemo